export default {
  loading: false,
  invoices: [],
  totalCount: 0,
};
